import { Box } from '@mui/material';

import ContextScoreCard from '@/components/home/cards/ContextScoreCard';
import HomeScoreCard from '@/components/home/cards/HomeScoreCard';
import InspectionSummaryVisualCard from '@/components/home/cards/InspectionSummaryVisualCard';

// /dev/overview: the Overview cards beside a Tradehaus Dark island drawn from its exact CSS (tx.css, data-skin graphite),
// so the two materials can be compared in one screenshot. Development builds only.

const tradehausIsland = {
  borderRadius: '24px',
  background: '#303030',
  backgroundImage: [
    'radial-gradient(120% 80% at 10% 0%, rgba(247, 247, 246, 0.055), rgba(247, 247, 246, 0.012) 45%, transparent 70%)',
    'linear-gradient(180deg, transparent 55%, rgba(0, 0, 0, 0.08))',
  ].join(', '),
  boxShadow: '0 24px 48px -24px rgba(0, 0, 0, 0.7)',
  color: '#f7f7f6',
  padding: '20px',
  minHeight: 300,
};

export const OverviewPreview = () => (
  <Box sx={{ minHeight: '100vh', p: '32px', display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: '20px', alignItems: 'start' }}>
    <div data-testid="tradehaus-ref" style={tradehausIsland}>
      Tradehaus Dark island (reference)
    </div>
    <HomeScoreCard />
    <ContextScoreCard />
    <Box sx={{ gridColumn: '1 / -1' }}>
      <InspectionSummaryVisualCard />
    </Box>
  </Box>
);

export default OverviewPreview;
